import { render, staticRenderFns } from "./ApiKeyForm.vue?vue&type=template&id=52a37ed0&scoped=true"
import script from "./ApiKeyForm.vue?vue&type=script&lang=js"
export * from "./ApiKeyForm.vue?vue&type=script&lang=js"
import style0 from "./ApiKeyForm.vue?vue&type=style&index=0&id=52a37ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a37ed0",
  null
  
)

export default component.exports